/**
 * Sets up the same listener on every element of a class.
 * @param {string} type - Which javascript event to listen on.
 * @param {function} listener - Method to evecute on the event.
 * @param {string} classname - Name of the class to attach the listener.
 */
export function addListenerToClassElements(type, listener, classname)
{
    let elements = document.getElementsByClassName(classname);
    for (const ele of elements) {
        ele.addEventListener(type, listener);
    }
}